import {KRAKEN_DIRS, THUMBNAIL_COLORS} from "data/products/index";

const DEFAULT_ACCENT_COLOR = THUMBNAIL_COLORS.WS;

function parseHexColor(value) {
  if (typeof value !== "string") return null;
  const trimmed = value.trim();
  const shortMatch = /^#([0-9a-fA-F]{3})$/.exec(trimmed);
  if (shortMatch) {
    const [r, g, b] = shortMatch[1].split("");
    return `#${r}${r}${g}${g}${b}${b}`.toUpperCase();
  }

  const longMatch = /^#([0-9a-fA-F]{6})$/.exec(trimmed);
  if (!longMatch) return null;
  return `#${longMatch[1].toUpperCase()}`;
}

function hexToRgb(hex) {
  const normalized = parseHexColor(hex);
  if (!normalized) return null;
  return {
    r: parseInt(normalized.slice(1, 3), 16),
    g: parseInt(normalized.slice(3, 5), 16),
    b: parseInt(normalized.slice(5, 7), 16),
  };
}

function getAccentScore(hex) {
  const rgb = hexToRgb(hex);
  if (!rgb) return -Infinity;

  const max = Math.max(rgb.r, rgb.g, rgb.b);
  const min = Math.min(rgb.r, rgb.g, rgb.b);

  const brightness = max / 255;
  const saturation = max === 0 ? 0 : (max - min) / max;

  // Prefer vivid and bright-enough colors, avoid muted grays.
  return saturation * 2 + (1 - Math.abs(brightness - 0.72));
}

function pickAccentFromPalette(palette) {
  if (!Array.isArray(palette) || palette.length === 0) {
    return null;
  }

  let best = null;
  let bestScore = -Infinity;

  palette.forEach((raw) => {
    const candidate = parseHexColor(raw);
    if (!candidate) return;
    const score = getAccentScore(candidate);
    if (score > bestScore) {
      best = candidate;
      bestScore = score;
    }
  });

  return best;
}

export function resolveProductAccentColor(productCode, palettes) {
  if (!productCode) {
    return DEFAULT_ACCENT_COLOR;
  }

  const builtInAccent = THUMBNAIL_COLORS[productCode];
  if (builtInAccent) {
    return builtInAccent;
  }

  const paletteKey = KRAKEN_DIRS[productCode];
  const productPalette = (paletteKey && palettes?.[paletteKey]) || palettes?.[productCode];

  const fromPalette = pickAccentFromPalette(productPalette);
  return fromPalette || DEFAULT_ACCENT_COLOR;
}
